export enum TipoSexo
{
    Masculino = "Masculino",
    Femenino = "Femenino",
}